// getters
const restaurantRequests = state => state.restaurantRequests

export default {
  restaurantRequests
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/requests/getters.js